module.exports = __webpack_public_path__ + "static/dk-promotion-air-solarcell-91161b51f46bc6c68381b48f9d37fd82.webp";